import styled from 'styled-components'

import Spinner from 'components/Spinner'
import ErrorMessage from 'components/ErrorMessage'

const ProcessingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  width: 100%;
  position: absolute;
`

const PageContent = styled.div`
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
`

const ProcessingMessage = styled(ErrorMessage)`
  max-width: 480px;
`

const PageLoading = styled(PageContent)`
  justify-content: center;
`

const StyledSpinner = styled(Spinner)`
  display: flex;
  align-self: center;
`

export {
  ProcessingContainer,
  PageContent,
  ProcessingMessage,
  PageLoading,
  StyledSpinner,
}
